/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { SignupForm } from "./signupTypes";

type Props = {
  form: SignupForm;
  countryLabel: string;
  onEditStep: (index: number) => void;
};

// Read-only recap shown on the last step so owners can catch typos before the workspace is created.
export const SignupReview = defineComponent<Props>({
  name: "SignupReview",
  props: ["form", "countryLabel", "onEditStep"],
  setup(props) {
    const { t } = useLocalization();

    const row = (
      label: string,
      primary: string,
      secondary: string,
      step: number,
    ) => (
      <div class="flex items-start justify-between gap-4 py-3">
        <div class="min-w-0">
          <dt class="text-xs font-medium uppercase tracking-wide text-base-content/50">
            {label}
          </dt>
          <dd class="mt-0.5 truncate text-sm font-medium text-base-content">
            {primary}
          </dd>
          <dd class="truncate text-xs text-base-content/60">{secondary}</dd>
        </div>
        <button
          type="button"
          class="btn btn-ghost btn-xs text-primary"
          onClick={() => props.onEditStep(step)}
        >
          {t("signup.review.edit")}
        </button>
      </div>
    );

    return () => {
      const form = props.form;
      return (
        <section class="mb-6 rounded-xl border border-base-300 bg-base-200/60 px-4">
          <dl class="divide-y divide-base-300">
            {row(
              t("signup.review.restaurant"),
              form.restaurantName,
              t(`signup.business.${form.restaurantType}`),
              0,
            )}
            {row(
              t("signup.review.region"),
              props.countryLabel,
              `${form.currency} · ${form.timezone}`,
              0,
            )}
            {row(t("signup.review.owner"), form.ownerName, form.ownerEmail, 1)}
          </dl>
        </section>
      );
    };
  },
});
